import * as React from 'react'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportDatesRange from '../../ExportFields/ExportDatesRange'
import ExportEmployeeSelector from '../../ExportFields/ExportEmployeeSelector'

interface Props {
  form: ReportsForm
  contractVersions: ContractVersions
}

const UsedTimeoffFields = ({ form, contractVersions }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} contractVersions={contractVersions} />
      <ExportDatesRange form={form} />
    </>
  )
}

export default UsedTimeoffFields
